import styled from 'styled-components'

type Props = {
	fixAlignment?: boolean
}

export const Wrapper = styled.div<Props>`
	display: flex;
	justify-content: space-around;
	align-items: center;
	margin-top: ${({ fixAlignment = false }) => (fixAlignment ? '1px' : '0')};
`
